export default {
	name: "RadioToggler",
	props: {
		values: {
			type: Array,
			reqiured: true,
			validator: (value) => {
				const LENGTH = 2;
				return value.length === LENGTH;
			},
		},
		translation: {
			type: Boolean,
			default: false,
		},
	},
	components: {},
	data() {
		return { activeSort: this.values[0] };
	},
	methods: { valueChanged },
};

function valueChanged() {
	this.activeSort = this.activeSort === this.values[0] ? this.values[1] : this.values[0];
	this.$emit("value-changed", this.activeSort);
}
